import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useDeviceType } from '@provider-portal/common/styles/useDeviceType';

import { setDeviceType } from 'rdx/theme/actions';

export function ThemeListener(): React.ReactElement | null {
  const dispatch = useDispatch();
  const deviceType = useDeviceType();

  useEffect(() => {
    dispatch(setDeviceType(deviceType));
  }, [dispatch, deviceType]);

  return null;
}
